// extracted by mini-css-extract-plugin
export var chip = "_4l-0";
export var filterDropdown = "_4l-5";
export var filterItem = "_4l-6";
export var icon = "_4l-1";
export var removeButton = "_4l-3";
export var removeIcon = "_4l-4";
export var separator = "_4l-2";